<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.route != '', 'has-danger' : validation.route != '' }">
                                        <label for="route" class="bmd-label-floating">Rota *</label>
                                        <input refs="route" type="text" class="form-control" v-model="form.route" />
                                        <label v-if="validation.route != ''" id="name-error" class="error" for="route">{{ validation.route }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'has-danger' : validation.module_id != '' }">
                                        <model-list-select 
                                            class="form-control"
                                            :list="modules"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.module_id"
                                            placeholder="Módulo">
                                        </model-list-select>
                                        <label v-if="validation.module_id != ''" id="icon-error" class="error" for="module_id">{{ validation.module_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group">
                                        <b-form-checkbox id="checkbox1"
                                                         v-model="form.is_show_menu"
                                                         value="1"
                                                         unchecked-value="0">
                                            Exibir no menu
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'functionalities.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            modules() {
                return this.$store.state.modules.itens;
            }
        },
        created: function () {
            this.getData();
        },
        data() {
            return {
                form: {
                    name: '',
                    route: '',
                    module_id: ''
                },
                validation: {
                    name: '',
                    route: '',
                    module_id: ''
                }
            }
        },
        methods: {
            onSubmit(_ev) {
                var self = this;
                var valid = true;

                self.validation.name = '';
                self.validation.route = '';
                self.validation.module_id = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.route == '') {
                    self.validation.route = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.module_id == '') {
                    self.validation.module_id = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');
                    
                    const response = self.$store.dispatch('functionalities/add', self.form);
                    
                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Funcionalidade cadastrada com sucesso!");
                        self.$router.push({'name': 'functionalities.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }

                            if (err.data.errors.icon !== undefined) {
                                self.validation.icon = err.data.errors.icon[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            },
            async getData() {
                var self = this;
                
                self.$root.$emit('onLoading');
                
                const response =  this.$store.dispatch('modules/all');
                
                response.then(function(){
                    self.$root.$emit('onLoading');
                });
                
                response.catch(function(){
                    self.$root.$emit('onLoading');
                });
            }
        }
    };
</script>